export default {
    'name': 'check',
    'width': '24',
    'height': '24',
    'viewBox': '0 0 24 24',
    'data': '<path fill-rule=\'evenodd\' clip-rule=\'evenodd\' d=\'M19.7188 7.10355C19.9141 6.90829 19.9141 6.59171 19.7188 6.39645C19.5235 6.20118 19.207 6.20118 19.0117 6.39645L8.62977 16.7784L4.10355 12.2522C3.90829 12.0569 3.59171 12.0569 3.39645 12.2522C3.20118 12.4474 3.20118 12.764 3.39645 12.9593L8.27621 17.839C8.47147 18.0343 8.78806 18.0343 8.98332 17.839L19.7188 7.10355Z\' fill=\'#42A463\'/>'
}
